import { cn } from '@design-system';

const SIZE = 36;
const STROKE_WIDTH = 3;
const RADIUS = (SIZE - STROKE_WIDTH) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

interface CircularProgressProps {
  currentIndex: number;
  totalSteps: number;
  duration: number;
  className?: string;
}

export function CircularProgress({
  currentIndex,
  totalSteps,
  duration,
  className,
}: CircularProgressProps) {
  return (
    <div className={cn('relative inline-flex items-center justify-center', className)}>
      <svg
        width={SIZE}
        height={SIZE}
        className="-rotate-90"
      >
        <circle
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="currentColor"
          strokeWidth={STROKE_WIDTH}
          className="text-primary/20"
        />
        <circle
          key={`progress-${currentIndex}`}
          cx={SIZE / 2}
          cy={SIZE / 2}
          r={RADIUS}
          fill="none"
          stroke="currentColor"
          strokeWidth={STROKE_WIDTH}
          strokeLinecap="round"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={CIRCUMFERENCE}
          className="text-primary animate-circular-progress"
          style={{ animationDuration: `${duration}ms` }}
        />
      </svg>
      <span className="text-muted-foreground absolute text-xs font-medium">
        {currentIndex + 1}/{totalSteps}
      </span>
    </div>
  );
}
